import axios from 'axios';
import { API_BASE_URL } from '../../../constants';
import { useEffect, useState } from 'react';
import KickImage from 'Reuseables/KickImage';

export function useFetchPopularSearchData(category: string, limit: number) {
  const [isFetching, setIsFetching] = useState<boolean>(false);
  const [data, setData] = useState<string[]>([]);

  useEffect(() => {
    setIsFetching(true);
    axios
      .get(
        category
          ? `${API_BASE_URL}/products/popular/search?category=${category}&limit=${limit}`
          : `${API_BASE_URL}/products/popular/search?limit=${limit}`,
      )
      .then((res) => {
        const newValue = res.data.data.map((product) =>
          product.query.replace(
            /[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/gi,
            ' ',
          ),
        );

        setData(newValue);
        setIsFetching(false);
      })
      .catch((err) => {
        console.error('failed to fetch', err);
        setIsFetching(false);
      });
  }, []);

  return {
    isFetching,
    data,
  };
}
